import { startOfDay } from 'date-fns';
import { InputHTMLAttributes } from 'react';
import { CollectConsignmentWithDate } from 'types';
import { Checkbox, Modal, Text } from 'components';
import { formatTimestamp } from 'helpers';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';
import { CollectProductList } from '../';

interface ScheduledConsignment extends CollectConsignmentWithDate {
  createdDate?: Date;
}

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  consignment: ScheduledConsignment;
  isCheckboxHidden?: boolean;
  hasCarrierCollectCode?: boolean;
}

export function CollectConsignment({
  consignment,
  isCheckboxHidden = false,
  hasCarrierCollectCode,
  disabled = false,
  ...rest
}: Props) {
  const { consignmentCode, user, collectCode, expectedDate, createdDate } =
    consignment;

  const isCheckboxRendering = !isCheckboxHidden && !disabled;

  const { day, month, hour, minute } = formatTimestamp(createdDate);
  const formattedDate = `${day}/${month} à${
    Number(hour) > 1 ? 's' : ''
  } ${hour}h${minute}`;

  const currentDate = new Date();
  const isCollectLate =
    expectedDate !== undefined
      ? startOfDay(expectedDate) < startOfDay(currentDate)
      : false;

  return (
    <S.Main
      $disabled={disabled}
      htmlFor={consignmentCode}
      $isLate={isCollectLate}
      $isCheckboxHidden={isCheckboxHidden}
    >
      <S.TitleWrapper $isLate={isCollectLate}>
        {isCheckboxRendering && (
          <Checkbox
            variant={isCollectLate ? 'danger' : 'neutral'}
            id={consignmentCode}
            {...rest}
          />
        )}

        <Text weight={FontWeight.bold} size={FontSize.font12}>
          {consignmentCode}
        </Text>
      </S.TitleWrapper>

      <S.Content>
        <Text size={FontSize.font10}>Cliente: {user}</Text>
        {hasCarrierCollectCode && collectCode && (
          <Text size={FontSize.font10}>Cód. de coleta: {collectCode}</Text>
        )}
      </S.Content>

      {isCheckboxHidden && (
        <S.CreatedDate>
          <Text size={FontSize.font10}>Pedido feito em {formattedDate}</Text>
        </S.CreatedDate>
      )}

      <S.DetailsButton>
        <Modal
          modalContent={
            <CollectProductList consignmentCode={consignmentCode} />
          }
        >
          <Text size={FontSize.font10} className="link-text">
            Ver detalhes
          </Text>
        </Modal>
        {isCollectLate && (
          <Text
            size={FontSize.font12}
            weight={FontWeight.bold}
            className="late-collect"
          >
            Coleta atrasada
          </Text>
        )}
      </S.DetailsButton>
    </S.Main>
  );
}
